<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu activeNav="Orders" childName="View Orders"></side-menu>
    <div class="content">
      <div class="dashboard">
        <heading :title="'Order Details'"></heading>
        <h1>Orders</h1>
        <div class="filters">
          <input
            type="text"
            placeholder="Search by order number, buyer name or email."
            class="search filter"
            v-model="query"
            @input="handleFilter"
          />
          <select
            id="date-filter"
            name="date-filter"
            class="date filter"
            v-model="selectedDateOption"
            @change="onDateFilterChange()"
          >
            <option
              v-for="(option, i) in date_filter_options"
              :key="i"
              :value="option.value"
              >{{ option.label }}</option
            >
          </select>
          <select
            id="date-filter"
            name="date-filter"
            class="date filter"
            v-model="selectedStatusOption"
            @change="onStatusFilterChange()"
          >
            <option
              v-for="(option, i) in status_filter_options"
              :key="i"
              :value="option.value"
              >{{ option.label }}</option
            >
          </select>
          <select
            id="ticket-filter"
            name="ticket-filter"
            class="ticket filter"
            v-model="selectedTicketOption"
            @change="onTicketFilterChange()"
          >
            <option key="all" value="all">All</option>
            <option
              v-for="(ticket, i) in tickets"
              :key="i"
              :value="ticket.name"
              >{{ ticket.name }}</option
            >
          </select>
        </div>
        <table class="orders">
          <thead>
            <td>Order #</td>
            <td class="sortable-td">
              Order Date<img
                @click="sort('created')"
                class="filter_icon"
                :class="
                  currentSort === 'created' && currentSortDir === 'desc'
                    ? 'down-arrow'
                    : null
                "
                src="@/assets/img/arrow.svg"
              />
            </td>
            <td class="sortable-td">
              Name<img
                @click="sort('buyer')"
                class="filter_icon"
                :class="
                  currentSort === 'buyer' && currentSortDir === 'desc'
                    ? 'down-arrow'
                    : null
                "
                src="@/assets/img/arrow.svg"
              />
            </td>

            <td class="sortable-td">
              Quantity<img
                @click="sort('quantity')"
                class="filter_icon"
                :class="
                  currentSort === 'quantity' && currentSortDir === 'desc'
                    ? 'down-arrow'
                    : null
                "
                src="@/assets/img/arrow.svg"
              />
            </td>
            <td>Ticket Type</td>
            <td class="sortable-td">
              Total Paid<img
                @click="sort('total_price')"
                class="filter_icon"
                :class="
                  currentSort === 'total_price' && currentSortDir === 'desc'
                    ? 'down-arrow'
                    : null
                "
                src="@/assets/img/arrow.svg"
              />
            </td>

            <td>Billing Address</td>
          </thead>

          <tbody>
            <tr
              v-for="(item, id) in sortedLineItems"
              @click="
                goTo('/event/' + item.event_id + '/orders/' + item.order_id)
              "
              :key="id"
            >
              <td>#{{ item.order_number }}</td>
              <td>{{ item.created | format_date_time }}</td>
              <td>{{ item.buyer }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.name }}</td>
              <td>${{ item.total_price }}</td>

              <td>
                {{
                  `${item.billing.address_1}, ${item.billing.city}, ${item.billing.state}`
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/Title.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import firebase from "firebase";
import moment from "moment";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;

export default {
  name: "orders",
  components: {
    "management-nav": managementBar,
    "side-menu": managementMenu,
    heading: Title,
  },
  data() {
    return {
      orders: {},
      line_items: [],
      tickets: [],
      date_filter_options: [
        { label: "All", value: 0 },
        { label: "Past 3 months", value: 3 },
        { label: "Past 6 months", value: 6 },
        { label: "Past 12 months", value: 12 },
      ],
      status_filter_options: [
        { label: "All", value: 0 },
        { label: "Published", value: "PUBLISHED" },
        { label: "Draft", value: "DRAFT" },
        { label: "Past", value: "PAST" },
      ],
      query: "",
      filtered_orders: [],
      selectedDateOption: 0,
      selectedStatusOption: 0,
      selectedTicketOption: "all",
      previousSelectedTicketOption: null,
      currentSort: "created",
      currentSortDir: "asc",
    };
  },
  async created() {
    await this.getOrders();
    await this.getTickets();
  },
  computed: {
    sortedLineItems: function() {
      return this.line_items.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === "desc") modifier = -1;
        let firstEl =
          typeof a[this.currentSort] === "string"
            ? a[this.currentSort].toLowerCase()
            : a[this.currentSort];
        let secondEl =
          typeof b[this.currentSort] === "string"
            ? b[this.currentSort].toLowerCase()
            : b[this.currentSort];
        if (firstEl < b[this.currentSort]) return -1 * modifier;
        if (firstEl > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    },
  },
  methods: {
    getOrders() {
      return db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("orders")
        .get()
        .then((snapshot) => {
          return snapshot.docs.map(async (doc) => {
            this.orders[doc.id] = Object.assign({ id: doc.id }, doc.data());
            return doc;
          });
        })
        .then(() => this.getLineItems());
    },
    async getLineItems() {
      for (const key in this.orders) {
        let order = this.orders[key];
        let line_items_ref = await db
          .collection("event")
          .doc(order.event_id)
          .collection("orders")
          .doc(key)
          .collection("line_items")
          .get();

        let line_items = line_items_ref.docs.map((doc) => {
          return Object.assign(
            {
              id: doc.id,
              order_id: key,
              order_number: order.order_number,
              created: order.created_at,
              buyer: order.payment_info.name,
              billing: order.billing_address,
            },
            doc.data()
          );
        });
        this.line_items = [].concat(this.line_items, line_items);
      }
    },
    async getTickets() {
      let tickets_ref = await db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("ticket")
        .get();

      let tickets = tickets_ref.docs.map((doc) => {
        return {
          id: doc.id,
          name: doc.data().name,
          description: doc.data().description,
        };
      });
      this.tickets = [].concat(this.tickets, tickets);
    },
    handleFilter() {
      if (this.query && this.line_items.length) {
        let query = this.query.toLowerCase();
        let filtered_line_items = this.line_items.filter((order) => {
          if (
            (order.buyer && order.buyer.toLowerCase().includes(query)) ||
            (order.order_number && order.order_number
              .toLowerCase()
              .includes(query)) ||
            (order.email && order.email.toLowerCase().includes(query))
          ) {
            return order;
          }
        });
        this.line_items = filtered_line_items;
      } else {
        this.line_items = [];
        return this.getOrders();
      }
    },
    onDateFilterChange() {
      if (this.selectedDateOption && this.line_items.length) {
        let now = moment();
        let pastXMonths = moment().subtract(this.selectedDateOption, "months");
        let filtered_line_items = this.line_items.filter((item) => {
          let itemDate = moment(item.created_at);
          if (itemDate.isBetween(pastXMonths, now, "months", true)) {
            return item;
          }
        });
        this.line_items = filtered_line_items;
      } else {
        this.line_items = [];
        return this.getOrders();
      }
    },
    onStatusFilterChange() {
      if (this.selectedStatusOption && this.line_items.length) {
        let filtered_line_items = this.line_items.filter((item) => {
          if (item.status === this.selectedStatusOption) {
            return item;
          }
        });
        return (this.line_items = filtered_line_items);
      } else {
        return this.getLineItems();
      }
    },
    onTicketFilterChange() {
      if (this.selectedTicketOption === "all") {
        this.line_items = [];
        return this.getOrders();
      }

      if (
        this.previousSelectedTicketOption &&
        this.previousSelectedTicketOption !== this.selectedTicketOption
      ) {
        this.getLineItems().then(() => {
          let filtered_line_items = this.line_items.filter((item) => {
            if (item.name === this.selectedTicketOption) {
              return item;
            }
          });
          this.previousSelectedTicketOption = this.selectedTicketOption;
          return (this.line_items = filtered_line_items);
        });
      } else if (this.selectedTicketOption && this.line_items.length) {
        let filtered_line_items = this.line_items.filter((item) => {
          if (item.name === this.selectedTicketOption) {
            return item;
          }
        });
        this.previousSelectedTicketOption = this.selectedTicketOption;
        return (this.line_items = filtered_line_items);
      } else {
        this.line_items = [];
        return this.getOrders();
      }
    },
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
    },
  },
};
</script>

<style lang="scss">
.orders {
  width: 100%;
  border-collapse: collapse;

  thead {
    background-color: #efefef;

    td {
      padding: 10px;
    }
  }

  tbody {
    td {
      padding: 20px 10px;
      border-bottom: 1px solid #eaeaea;
      background-color: transparent;
    }

    tr {
      background-color: white;
      transition: background-color 0.3s;
      cursor: pointer;

      &:hover {
        background-color: #f7f7f7;
      }
    }
  }
}
.filters {
  display: flex;
  flex-direction: row;
  margin-top: 24px;
  margin-bottom: 10px;
}
.search {
  width: 65%;
}
#date-filter,
#ticket-filter {
  background-color: white;
  border: none;
  outline: none;
  padding: 10px 15px;
  font-size: 17px;
  color: #0d0d0d;
  width: 25%;
  box-shadow: 0 0 8px rgba(128, 128, 128, 0.2);
  margin-left: 8px;
}
.filter_icon {
  height: 15px;
  margin-left: 10px;
  padding-top: 1px;
}
.filter_icon:hover {
  cursor: pointer;
}
.down-arrow {
  transform: rotateZ(180deg);
}
</style>
